<template>
  <div class="rbz-card white certificate-card rbz-columns">
    <div class="rbz-column">
      <template v-if="isCertificatePlaceholder"> {{ certificateDetails.name }}(*) </template>
      <template v-else-if="certificateDetails">
        <span class="certificate-card-line">
          {{ $t('sslLoadBalancer.certificateCard.name') }} {{ certificateDetails.name }}
        </span>
        <span class="certificate-card-line">
          {{ $t('sslLoadBalancer.certificateCard.cn') }} {{ certificateDetails.cn }}
        </span>
        <span class="certificate-card-line">
          {{ $t('sslLoadBalancer.certificateCard.san') }} {{ certificateDetails.san.join(', ') }}
        </span>
        <span class="certificate-card-line">
          {{ $t('sslLoadBalancer.certificateCard.expiration') }} {{ certificateDetails?.expDate }}
        </span>
      </template>
    </div>
    <div class="rbz-column is-narrow buttons-column" v-if="$slots.buttons">
      <slot name="buttons" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { CertificateDetails } from '@/types';
import { computed } from 'vue';

interface SslLoadBalancersCertificateCard {
  certificateDetails: CertificateDetails;
}

const props = defineProps<SslLoadBalancersCertificateCard>();

const isCertificatePlaceholder = computed(() => {
  return props.certificateDetails?.id === 'placeholder';
});
</script>

<style lang="scss">
.certificate-card {
  padding: 16px;

  .certificate-card-line {
    display: block;
  }

  .certificate-card-line:not(:last-child) {
    margin-bottom: 8px;
  }

  .buttons-column {
    display: flex;
    gap: 10px;
  }
}
</style>
